
import { RouterProvider } from "@tanstack/react-router";
import { Provider } from "react-redux";

import { router } from "@/routes/appRoutes";
import { store } from "@/store";
import { GlobalPollingModal } from "@/components/common/GlobalPollingModal/GlobalPollingModal";

function App() {
    return (
    <Provider store={store}>
      {/* <AppContent /> */}
      <RouterProvider router={router} />
      <GlobalPollingModal />
    </Provider>
  );
}

export default App;
